import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReportInfo } from 'store/api/apiTypes';

interface HistoryState {
  historyMode: boolean;
  activeReport?: ReportInfo; // currently selected report (can be undefined)
}

const initialState: HistoryState = {
  historyMode: false,
  activeReport: undefined,
};

const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setHistoryMode: (state, action: PayloadAction<boolean>) => {
      state.historyMode = action.payload;
    },
    activateHistoryMode: (
      state,
      action: PayloadAction<ReportInfo | undefined>
    ) => {
      state.historyMode = true;
      if (action && action.payload) {
        state.activeReport = action.payload;
      }
    },
    deactivateHistoryMode: state => {
      state.historyMode = false;
      state.activeReport = undefined;
    },
    toggleHistoryMode: state => {
      state.historyMode = !state.historyMode;
    },
    setActiveReport: (state, action: PayloadAction<ReportInfo | undefined>) => {
      state.activeReport = action.payload;
    },
  },
});

export const {
  setHistoryMode,
  activateHistoryMode,
  deactivateHistoryMode,
  toggleHistoryMode,
  setActiveReport,
} = historySlice.actions;
export default historySlice.reducer;
